export const REVIEWER_PERFORMANCE_MAX_DAYS = 730;
